module.exports = __webpack_public_path__ + "static/img/1.6f2fda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.png
// module id = Txl5
// module chunks = 40